import React from "react";
import { useTranslation } from "react-i18next";
import "../InvoiceModal.css";

// components imports
import CarrierTableLoader from "../../../Components/CarrierInnerTableLoader/CarrierInnerTableLoader";
// apis imports
// library imports
import { FaRegTimesCircle } from "react-icons/fa";
import { MdArrowCircleDown } from "react-icons/md";
import International from "./InvoiceSubComponents/International";
import ShipmentSummary from "./InvoiceSubComponents/ShipmentSummary";
import Tracking from "./InvoiceSubComponents/Tracking";
import Header from "./InvoiceSubComponents/Header";
import ShipmentDetails from "./InvoiceSubComponents/ShipmentDetails";
import Footer from "./InvoiceSubComponents/Footer";
import BillingAdmin from "./InvoiceSubComponents/BillingAdmin";
import AdminActions from "./InvoiceSubComponents/AdminActions";
import NotesAdmin from "./InvoiceSubComponents/NotesAdmin";
import CarrierBill from "./InvoiceSubComponents/CarrierBill";
import QuotePrice from "./InvoiceSubComponents/QuotePrice";
import OneTimeShipperAdminApproval from "./OneTimeShipperAdminApproval";
import EstimatePrice from "./InvoiceSubComponents/EstimatePrice";
import InvoiceActionsDropdown from "./InvoiceSubComponents/InvoiceActionsWithDocs";

const EditableInvoice = ({
  data,
  setData,
  handleClose,
  downloadPdf,
  printLabel,
  downloadDocs,
  setShipments,
  getAllShipments,
  loading,
  refreshShipmentData,
  setSnack,
}) => {
  const { t } = useTranslation("finances");
  return (
    <div className="invoice__modal_wrap invoice__modal_style_optamize_wrap static__invoice_wrap">
      {loading === false ? (
        <div className="invoice__modal_box invoice__shipment_style_optamize_wrap">
          <div className="invoice__modal_downloadinvoicewrap">
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
              {/* Download Invoice */}
              <button
                onClick={() => downloadPdf(data)}
                className="flex items-center gap-1.5 rounded-md bg-brand px-2.5 py-1.5 text-xs font-medium text-white shadow hover:bg-brand-hover
               sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
              >
                <MdArrowCircleDown className="h-4 w-4 sm:h-5 sm:w-5" />
                <span>{t("invoice.buttons.invoice")}</span>
              </button>

              {/* Download Label */}
              <button
                onClick={() => downloadDocs(data, "label")}
                className="flex items-center gap-1.5 rounded-md border border-ui-border bg-ui-surface px-2.5 py-1.5 text-xs font-medium text-ui-text
               hover:bg-ui-surface-sunken sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
              >
                <MdArrowCircleDown className="h-4 w-4 sm:h-5 sm:w-5" />
                <span>{t("invoice.buttons.label")}</span>
              </button>

              {/* Manage Declaration */}
              {data?.single_shipping_invoice && (
                <>
                  <InvoiceActionsDropdown
                    documents={data?.shipping_document || []}
                    shipmentId={data?.id}
                    onDownloadDeclaration={() =>
                      downloadDocs(data, "declaration")
                    }
                    onDownloadAllZip={() => {}}
                    onDocumentsUpdate={(documents) => {
                      setData((prev) => ({
                        ...prev,
                        shipping_document: documents,
                      }));
                    }}
                    onDocumentDelete={(deleteId) => {
                      setData((prev) => ({
                        ...prev,
                        shipping_document: prev.shipping_document.filter(
                          (d) => d.id !== deleteId,
                        ),
                      }));
                    }}
                  />
                </>
              )}

              {/* Close */}
              <button
                onClick={handleClose}
                className="flex items-center gap-1.5 rounded-md bg-state-danger px-2.5 py-1.5 text-xs font-medium text-white shadow
             hover:bg-state-danger sm:gap-2 sm:px-3 sm:py-2 sm:text-sm sm:leading-none"
              >
                <FaRegTimesCircle className="h-4 w-4 sm:h-5 sm:w-5" />
                <span className="hidden sm:inline">
                  {t("common:actions.close")}
                </span>
              </button>
            </div>
          </div>
          <Header data={data} />
          {data?.shipment_type === "oneTimeShipper" && (
            <OneTimeShipperAdminApproval
              shipmentData={data}
              refreshShipmentData={refreshShipmentData}
              setSnack={setSnack}
              getAllShipments={getAllShipments}
            />
          )}
          <ShipmentSummary data={data} />
          <International data={data} />
          <ShipmentDetails data={data} type="admin" />

          <AdminActions
            data={data}
            setShipments={setShipments}
            setData={setData}
            getAllShipments={getAllShipments}
            type="admin"
          />
          <AdminActions
            data={data}
            setShipments={setShipments}
            setData={setData}
            getAllShipments={getAllShipments}
            type="admin-user"
          />

          {data?.estCharges?.length > 0 && <EstimatePrice data={data} />}

          {data?.billingAutomation?.length > 0 && <CarrierBill data={data} />}

          {data?.quoteCharges?.length > 0 && <QuotePrice data={data} />}

          <BillingAdmin
            data={data}
            setData={setData}
            setShipments={setShipments}
          />

          <NotesAdmin
            data={data}
            setShipments={setShipments}
            setData={setData}
            getAllShipments={getAllShipments}
          />
          <Tracking data={data} />
          <Footer data={data} />
        </div>
      ) : (
        <div className="fulfilment_tier_loader">
          <CarrierTableLoader />
        </div>
      )}
    </div>
  );
};

export default EditableInvoice;
